const prizesSlider = document.querySelector('.prizes-list.swiper-container');
let swiperPrizes;

// eslint-disable-next-line no-undef
const initSwiper = (slider) => new Swiper(slider, {
  speed: 800,
  slidesPerView: 3,
  loop: true,
  centeredSlides: true,
  navigation: {
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next',
  },

  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    767: {
      slidesPerView: 2,
      spaceBetween: 50,
      centeredSlides: false,
    },
    1000: {
      slidesPerView: 3.45,
      spaceBetween: 105,
      centeredSlides: true,
    },
    2000: {
      slidesPerView: 3.2,
      spaceBetween: 105,
      centeredSlides: true,
    },
  },
});

const initPrizeSlider = () => {
  if (prizesSlider) {
    const prizeSlides = prizesSlider.querySelectorAll('.swiper-slide');

    if (prizeSlides.length > 1) {
      swiperPrizes = initSwiper(prizesSlider);

      window.addEventListener('resize', function () {
        swiperPrizes.update();
      });
    }
  }
};


export {initPrizeSlider};
